import React from "react";

import classnames from "classnames/bind";
import styles from "./PieChartTooltip.module.scss";

import { CircleIcon } from "../../components/Icons";

import type { PieChartTooltipProps } from "./types";

const cx = classnames.bind(styles);

const PieChartTooltip = ({
  tooltipData,
  label,
  value,
}: PieChartTooltipProps) => {
  return (
    <div
      className={cx("tooltipContainer")}
      role="tooltip"
    >
      <span className={cx("label")}>
        <svg
          width={12}
          height={12}
          className={cx("indicator")}
        >
          <CircleIcon fill={tooltipData?.fill} />
        </svg>

        {label}
      </span>

      <span className={cx("value")}>{value}</span>
    </div>
  );
};

export default PieChartTooltip;
